import styles from './text-blur-button.module.sass';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

export default function TextBlurButton({ children, onClick, theme = 'blue' }) {
  const className = cx({
    [theme]: true,
    edit: true,
  });

  return (
    <span className={className} onClick={onClick}>
      {children}
    </span>
  );
}
